import { createContext } from 'react';

const GlobalConversationsContext = createContext();

export default GlobalConversationsContext;
